exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dialog-header-content > h3 {\r\n    margin: 0;\r\n}\r\n\r\n.dialog-header-content > span {\r\n    color: #777;\r\n}\r\n\r\n.loading-label {\r\n    float: left;\r\n    line-height: 35px;\r\n}\r\n\r\n.graph-legend-container {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-bottom: 5px;\r\n    float: right;\r\n    margin-right: 50px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/licensing-overview/license-contract-details.css
// module id = app/components/licensing-overview/license-contract-details.css
// module chunks = 0